import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M8.829 14.225c.554.84 1.788.84 2.342 0l4.321-6.549A1.404 1.404 0 0 0 14.321 5.5H5.679a1.404 1.404 0 0 0-1.171 2.176l4.32 6.549Z" />
  </svg>
);
export default SvgDown;
